module.exports = "<div class=\"box\">\n  <div class=\"box-row\">\n    <div class=\"box-cell\">\n      <div class=\"box-inner padding-box\" ui-view id=\"view\">\n\n      </div>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/layout/content.html
// module id = 84
// module chunks = 0